import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "undo", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "redo", -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.undo && _ctx.undo(...args))),
      disabled: !_ctx.isUndoable,
      style: _normalizeStyle(`opacity:${_ctx.isUndoable ? '1.0' : '0.5'}`)
    }, _hoisted_3, 12, _hoisted_1),
    _createElementVNode("button", {
      style: _normalizeStyle(`opacity:${_ctx.isRedoable ? '1.0' : '0.5'}`),
      class: "ml-1",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redo && _ctx.redo(...args))),
      disabled: !_ctx.isRedoable
    }, _hoisted_6, 12, _hoisted_4)
  ]))
}